{
  "level": "jct02",
  "source": {
    "spawn": "DERIVED_FROM_TREES_BBOX:jct02",
    "objects": "AREAS.E3:jct02.e3",
    "mesh": "TREES.E3:jct02.e3"
  },
  "spawn_point": {
    "position": [
      -3294.513174267778,
      -4885.832216437159,
      1023.7071533203125
    ],
    "facing_rad": 0.0,
    "look_point": [
      -3294.513174267778,
      -4785.832216437159,
      1023.7071533203125
    ],
    "forward": [
      0.0,
      1.0,
      0.0
    ],
    "up": [
      0.0,
      0.0,
      1.0
    ],
    "derived": true
  },
  "mesh_point_cloud": {
    "note": "Raw vertex positions from TREES.E3.",
    "bbox_min": [
      -3505.0,
      -4965.7685546875,
      999.7071533203125
    ],
    "bbox_max": [
      -3128.943359375,
      -4498.0380859375,
      1152.7071533203125
    ],
    "vertex_count": 733,
    "vertices": [
      [
        -3164.084228515625,
        -4629.7685546875,
        1052.623779296875
      ],
      [
        -3164.084228515625,
        -4498.0380859375,
        1052.623779296875
      ],
      [
        -3128.943359375,
        -4949.3310546875,
        1101.623779296875
      ],
      [
        -3128.943359375,
        -4965.7685546875,
        1101.623779296875
      ],
      [
        -3144.960693359375,
        -4895.201171875,
        1079.289794921875
      ],
      [
        -3150.182861328125,
        -4891.7119140625,
        1072.0078125
      ],
      [
        -3231.976806640625,
        -4919.7685546875,
        1049.7071533203125
      ],
      [
        -3231.976318359375,
        -4919.7685546875,
        999.7071533203125
      ],
      [
        -3272.123046875,
        -4957.66845703125,
        1110.7071533203125
      ],
      [
        -3257.5,
        -4954.35546875,
        1110.7071533203125
      ],
      [
        -3238.341552734375,
        -4950.0146484375,
        1110.7071533203125
      ],
      [
        -3257.5,
        -4954.35498046875,
        1110.7071533203125
      ],
      [
        -3272.1240234375,
        -4957.66845703125,
        1110.7071533203125
      ],
      [
        -3285.859619140625,
        -4960.78076171875,
        1110.7071533203125
      ],
      [
        -3290.038330078125,
        -4963.96142578125,
        1110.7071533203125
      ],
      [
        -3210.70556640625,
        -4926.255859375,
        1128.572509765625
      ],
      [
        -3231.9150390625,
        -4932.2890625,
        1152.7071533203125
      ],
      [
        -3268.696044921875,
        -4947.71728515625,
        1122.7071533203125
      ],
      [
        -3258.315185546875,
        -4939.81591796875,
        1152.7071533203125
      ],
      [
        -3281.770751953125,
        -4957.66845703125,
        1110.7071533203125
      ],
      [
        -3272.84814453125,
        -4950.87744140625,
        1110.7071533203125
      ],
      [
        -3281.770751953125,
        -4957.66845703125,
        1110.7071533203125
      ],
      [
        -3238.541748046875,
        -4949.900390625,
        1110.7071533203125
      ],
      [
        -3238.840087890625,
        -4950.12744140625,
        1110.7071533203125
      ],
      [
        -3257.5,
        -4950.25390625,
        1110.7071533203125
      ],
      [
        -3266.550048828125,
        -4952.3046875,
        1110.7071533203125
      ],
      [
        -3243.487548828125,
        -4947.07958984375,
        1110.7071533203125
      ],
      [
        -3257.5,
        -4950.25390625,
        1110.7071533203125
      ],
      [
        -3205.8193359375,
        -4921.78955078125,
        1110.7071533203125
      ],
      [
        -3207.578857421875,
        -4924.78955078125,
        1122.7071533203125
      ],
      [
        -3245.08642578125,
        -4942.31396484375,
        1110.7071533203125
      ],
      [
        -3245.08642578125,
        -4942.31396484375,
        1098.7071533203125
      ],
      [
        -3247.98046875,
        -4944.51708984375,
        1110.7071533203125
      ],
      [
        -3254.677734375,
        -4949.61474609375,
        1110.7071533203125
      ],
      [
        -3210.4306640625,
        -4919.7685546875,
        1098.7071533203125
      ],
      [
        -3210.4306640625,
        -4919.7685546875,
        1102.6231689453125
      ],
      [
        -3211.615966796875,
        -4921.78955078125,
        1110.7071533203125
      ],
      [
        -3249.4140625,
        -4933.041015625,
        1074.7071533203125
      ],
      [
        -3257.5,
        -4939.1953125,
        1086.7071533203125
      ],
      [
        -3254.017578125,
        -4936.544921875,
        1086.7071533203125
      ],
      [
        -3236.62109375,
        -4932.60302734375,
        1086.7071533203125
      ],
      [
        -3258.314697265625,
        -4939.8154296875,
        1086.7071533203125
      ],
      [
        -3257.5,
        -4939.1953125,
        1086.7071533203125
      ],
      [
        -3230.508544921875,
        -4931.21826171875,
        1086.7071533203125
      ],
      [
        -3236.62109375,
        -4932.60302734375,
        1086.7071533203125
      ],
      [
        -3268.696044921875,
        -4947.71728515625,
        1110.7071533203125
      ],
      [
        -3268.696044921875,
        -4947.71728515625,
        1122.7071533203125
      ],
      [
        -3268.6962890625,
        -4947.71728515625,
        1110.7071533203125
      ],
      [
        -3263.505615234375,
        -4943.7666015625,
        1110.7071533203125
      ],
      [
        -3258.314697265625,
        -4939.8154296875,
        1097.7071533203125
      ],
      [
        -3258.314697265625,
        -4939.8154296875,
        1086.7071533203125
      ],
      [
        -3249.921630859375,
        -4937.873046875,
        1097.7071533203125
      ],
      [
        -3258.23876953125,
        -4939.7578125,
        1097.7071533203125
      ],
      [
        -3258.314697265625,
        -4939.8154296875,
        1097.7071533203125
      ],
      [
        -3223.72119140625,
        -4919.7685546875,
        1074.7071533203125
      ],
      [
        -3231.976806640625,
        -4919.7685546875,
        1049.7071533203125
      ],
      [
        -3219.758544921875,
        -4919.7685546875,
        1086.7071533203125
      ],
      [
        -3218.022216796875,
        -4919.7685546875,
        1086.7071533203125
      ],
      [
        -3216.227294921875,
        -4919.7685546875,
        1086.7071533203125
      ],
      [
        -3218.022216796875,
        -4919.7685546875,
        1086.7071533203125
      ],
      [
        -3216.227294921875,
        -4919.7685546875,
        1086.7071533203125
      ],
      [
        -3216.227294921875,
        -4919.7685546875,
        1097.4007568359375
      ],
      [
        -3216.5751953125,
        -4920.36181640625,
        1098.7071533203125
      ],
      [
        -3223.72119140625,
        -4919.7685546875,
        1086.7071533203125
      ],
      [
        -3223.72119140625,
        -4919.7685546875,
        1074.7071533203125
      ],
      [
        -3242.2626953125,
        -4933.88134765625,
        1086.7071533203125
      ],
      [
        -3223.72119140625,
        -4919.7685546875,
        1086.7071533203125
      ],
      [
        -3216.227294921875,
        -4919.7685546875,
        1098.7071533203125
      ],
      [
        -3249.4140625,
        -4933.041015625,
        1086.7071533203125
      ],
      [
        -3249.4140625,
        -4933.041015625,
        1074.7071533203125
      ],
      [
        -3249.4140625,
        -4933.041015625,
        1086.7071533203125
      ],
      [
        -3249.921630859375,
        -4933.42724609375,
        1097.7071533203125
      ],
      [
        -3283.0849609375,
        -4932.2890625,
        1152.7071533203125
      ],
      [
        -3304.29443359375,
        -4926.255859375,
        1128.572509765625
      ],
      [
        -3421.5,
        -4919.7685546875,
        1081.7071533203125
      ],
      [
        -3421.5,
        -4919.7685546875,
        1093.7071533203125
      ],
      [
        -3277.31396484375,
        -4954.2763671875,
        1110.7071533203125
      ],
      [
        -3280.234130859375,
        -4952.0537109375,
        1110.7071533203125
      ],
      [
        -3272.847900390625,
        -4950.876953125,
        1110.7071533203125
      ],
      [
        -3276.657958984375,
        -4950.01416015625,
        1110.7071533203125
      ],
      [
        -3276.45849609375,
        -4949.900390625,
        1110.7071533203125
      ],
      [
        -3276.1611328125,
        -4950.12646484375,
        1110.7071533203125
      ],
      [
        -3272.076904296875,
        -4946.951171875,
        1110.7071533203125
      ],
      [
        -3272.076904296875,
        -4946.951171875,
        1122.7071533203125
      ],
      [
        -3269.8837890625,
        -4948.62109375,
        1110.7071533203125
      ],
      [
        -3271.73876953125,
        -4947.20849609375,
        1110.7071533203125
      ],
      [
        -3309.1806640625,
        -4921.78955078125,
        1110.7071533203125
      ],
      [
        -3307.421142578125,
        -4924.78955078125,
        1122.7071533203125
      ],
      [
        -3278.378662109375,
        -4932.6025390625,
        1086.7071533203125
      ],
      [
        -3257.5,
        -4937.33349609375,
        1086.7071533203125
      ],
      [
        -3257.5,
        -4937.33349609375,
        1086.7071533203125
      ],
      [
        -3255.615478515625,
        -4937.7607421875,
        1086.7071533203125
      ],
      [
        -3284.4921875,
        -4931.2177734375,
        1086.7071533203125
      ],
      [
        -3278.378662109375,
        -4932.6025390625,
        1086.7071533203125
      ],
      [
        -3268.69580078125,
        -4947.716796875,
        1110.7071533203125
      ],
      [
        -3271.511962890625,
        -4947.0791015625,
        1110.7071533203125
      ],
      [
        -3284.4921875,
        -4931.2177734375,
        1086.7071533203125
      ],
      [
        -3279.889404296875,
        -4934.7216796875,
        1098.7071533203125
      ],
      [
        -3265.078369140625,
        -4937.8720703125,
        1097.7071533203125
      ],
      [
        -3257.898681640625,
        -4939.49853515625,
        1097.7071533203125
      ],
      [
        -3265.078369140625,
        -4937.8720703125,
        1097.7071533203125
      ],
      [
        -3265.078369140625,
        -4938.07763671875,
        1098.7071533203125
      ],
      [
        -3286.93115234375,
        -4923.07763671875,
        1074.7071533203125
      ],
      [
        -3304.5693359375,
        -4919.7685546875,
        1098.7071533203125
      ],
      [
        -3303.384033203125,
        -4921.78955078125,
        1110.7071533203125
      ],
      [
        -3304.5693359375,
        -4919.7685546875,
        1102.6231689453125
      ],
      [
        -3297.90576171875,
        -4920.59130859375,
        1086.7071533203125
      ],
      [
        -3292.573486328125,
        -4921.79931640625,
        1086.7071533203125
      ],
      [
        -3298.34912109375,
        -4920.49072265625,
        1086.7071533203125
      ],
      [
        -3297.90576171875,
        -4920.59130859375,
        1086.7071533203125
      ],
      [
        -3298.34912109375,
        -4920.49072265625,
        1086.7071533203125
      ],
      [
        -3298.34912109375,
        -4920.49072265625,
        1098.7071533203125
      ],
      [
        -3247.93408203125,
        -4931.91455078125,
        1070.8489990234375
      ],
      [
        -3254.017822265625,
        -4936.544921875,
        1086.7071533203125
      ],
      [
        -3286.93115234375,
        -4923.07763671875,
        1086.7071533203125
      ],
      [
        -3286.93115234375,
        -4923.07763671875,
        1086.7071533203125
      ],
      [
        -3286.93115234375,
        -4923.07763671875,
        1074.7071533203125
      ],
      [
        -3249.921630859375,
        -4931.46435546875,
        1097.7071533203125
      ],
      [
        -3265.078369140625,
        -4928.02978515625,
        1097.7071533203125
      ],
      [
        -3265.078369140625,
        -4928.02978515625,
        1097.7071533203125
      ],
      [
        -3265.078369140625,
        -4928.02978515625,
        1098.7071533203125
      ],
      [
        -3249.921630859375,
        -4928.02978515625,
        1097.7071533203125
      ],
      [
        -3257.5,
        -4929.7470703125,
        1097.7071533203125
      ],
      [
        -3283.023193359375,
        -4919.7685546875,
        1049.7071533203125
      ],
      [
        -3283.023681640625,
        -4919.7685546875,
        999.7071533203125
      ],
      [
        -3291.27880859375,
        -4919.7685546875,
        1074.7071533203125
      ],
      [
        -3283.023193359375,
        -4919.7685546875,
        1049.7071533203125
      ],
      [
        -3298.772705078125,
        -4919.7685546875,
        1086.7071533203125
      ],
      [
        -3298.424072265625,
        -4920.36279296875,
        1098.7071533203125
      ],
      [
        -3298.772705078125,
        -4919.7685546875,
        1097.400146484375
      ],
      [
        -3296.977783203125,
        -4919.7685546875,
        1086.7071533203125
      ],
      [
        -3295.241943359375,
        -4919.7685546875,
        1086.7071533203125
      ],
      [
        -3292.573486328125,
        -4921.79931640625,
        1086.7071533203125
      ],
      [
        -3298.772705078125,
        -4919.7685546875,
        1086.7071533203125
      ],
      [
        -3296.977783203125,
        -4919.7685546875,
        1086.7071533203125
      ],
      [
        -3291.27880859375,
        -4919.7685546875,
        1086.7071533203125
      ],
      [
        -3291.27880859375,
        -4919.7685546875,
        1074.7071533203125
      ],
      [
        -3291.27880859375,
        -4919.7685546875,
        1086.7071533203125
      ],
      [
        -3298.772705078125,
        -4919.7685546875,
        1098.7071533203125
      ],
      [
        -3249.921630859375,
        -4919.7685546875,
        1097.7071533203125
      ],
      [
        -3265.078369140625,
        -4919.7685546875,
        1097.7071533203125
      ],
      [
        -3265.078369140625,
        -4919.7685546875,
        1097.7071533203125
      ],
      [
        -3265.078369140625,
        -4919.7685546875,
        1098.7071533203125
      ],
      [
        -3236.05029296875,
        -4902.53564453125,
        1033.6912841796875
      ],
      [
        -3232.5146484375,
        -4906.0712890625,
        1047.8343505859375
      ],
      [
        -3232.5146484375,
        -4899.00048828125,
        1019.5502319335938
      ],
      [
        -3236.05029296875,
        -4902.53564453125,
        1033.6912841796875
      ],
      [
        -3224.504638671875,
        -4914.0810546875,
        1049.7071533203125
      ],
      [
        -3224.504638671875,
        -4914.08154296875,
        999.7071533203125
      ],
      [
        -3220.936767578125,
        -4917.64892578125,
        1074.7071533203125
      ],
      [
        -3224.504638671875,
        -4914.0810546875,
        1049.7071533203125
      ],
      [
        -3213.89306640625,
        -4915.78955078125,
        1086.7071533203125
      ],
      [
        -3214.523193359375,
        -4916.86376953125,
        1091.00341796875
      ],
      [
        -3216.227294921875,
        -4919.7685546875,
        1097.400634765625
      ],
      [
        -3209.8564453125,
        -4918.78955078125,
        1098.7071533203125
      ],
      [
        -3218.824462890625,
        -4919.0576171875,
        1086.7071533203125
      ],
      [
        -3218.817138671875,
        -4919.7685546875,
        1086.7071533203125
      ],
      [
        -3219.22412109375,
        -4919.36181640625,
        1086.7071533203125
      ],
      [
        -3213.89306640625,
        -4915.78955078125,
        1086.7071533203125
      ],
      [
        -3218.824462890625,
        -4919.0576171875,
        1086.7071533203125
      ],
      [
        -3214.530517578125,
        -4915.78955078125,
        1086.7071533203125
      ],
      [
        -3217.93017578125,
        -4912.78955078125,
        1074.7071533203125
      ],
      [
        -3218.934814453125,
        -4909.84228515625,
        1062.9178466796875
      ],
      [
        -3215.653076171875,
        -4918.78955078125,
        1098.7071533203125
      ],
      [
        -3216.906982421875,
        -4915.78955078125,
        1086.7071533203125
      ],
      [
        -3219.689697265625,
        -4915.7890625,
        1086.7071533203125
      ],
      [
        -3217.93017578125,
        -4912.78955078125,
        1074.7071533203125
      ],
      [
        -3220.838134765625,
        -4917.74755859375,
        1086.7071533203125
      ],
      [
        -3219.689697265625,
        -4915.7890625,
        1086.7071533203125
      ],
      [
        -3220.936767578125,
        -4917.64892578125,
        1086.7071533203125
      ],
      [
        -3220.936767578125,
        -4917.64892578125,
        1074.7071533203125
      ],
      [
        -3220.936767578125,
        -4917.64892578125,
        1086.7071533203125
      ],
      [
        -3220.060791015625,
        -4906.5400390625,
        1049.7071533203125
      ],
      [
        -3213.9169921875,
        -4896.06591796875,
        1007.8123168945312
      ],
      [
        -3220.060791015625,
        -4906.5400390625,
        1049.7071533203125
      ],
      [
        -3213.9169921875,
        -4896.06591796875,
        1007.8123168945312
      ],
      [
        -3213.563232421875,
        -4894.03955078125,
        999.7071533203125
      ],
      [
        -3278.94970703125,
        -4902.53515625,
        1033.689208984375
      ],
      [
        -3282.4853515625,
        -4899.0,
        1019.5482177734375
      ],
      [
        -3286.02099609375,
        -4902.53515625,
        1033.689208984375
      ],
      [
        -3282.4853515625,
        -4899.0,
        1019.5482177734375
      ],
      [
        -3300.4296875,
        -4916.943359375,
        1086.7071533203125
      ],
      [
        -3298.772705078125,
        -4919.7685546875,
        1097.400146484375
      ],
      [
        -3300.4296875,
        -4916.94384765625,
        1091.1790771484375
      ],
      [
        -3296.17578125,
        -4919.0576171875,
        1086.7071533203125
      ],
      [
        -3295.241455078125,
        -4919.7685546875,
        1086.7071533203125
      ],
      [
        -3300.4296875,
        -4916.943359375,
        1086.7071533203125
      ],
      [
        -3299.791748046875,
        -4916.3056640625,
        1086.7071533203125
      ],
      [
        -3296.176025390625,
        -4919.0576171875,
        1086.7071533203125
      ],
      [
        -3296.776123046875,
        -4913.2900390625,
        1074.7071533203125
      ],
      [
        -3294.51123046875,
        -4911.025390625,
        1059.2088623046875
      ],
      [
        -3299.346923828125,
        -4918.78955078125,
        1098.7071533203125
      ],
      [
        -3300.4296875,
        -4916.94384765625,
        1091.323486328125
      ],
      [
        -3299.275390625,
        -4915.78955078125,
        1086.7071533203125
      ],
      [
        -3298.0927734375,
        -4915.78955078125,
        1086.7071533203125
      ],
      [
        -3296.506591796875,
        -4915.7890625,
        1086.7071533203125
      ],
      [
        -3295.310302734375,
        -4915.7890625,
        1086.7071533203125
      ],
      [
        -3296.776123046875,
        -4913.2900390625,
        1076.7095947265625
      ],
      [
        -3296.776123046875,
        -4913.2900390625,
        1074.7071533203125
      ],
      [
        -3295.310302734375,
        -4915.7890625,
        1086.7071533203125
      ],
      [
        -3293.12255859375,
        -4909.63671875,
        1049.7071533203125
      ],
      [
        -3293.12255859375,
        -4909.63671875,
        999.7071533203125
      ],
      [
        -3293.12255859375,
        -4909.63671875,
        1049.7071533203125
      ],
      [
        -3262.9453125,
        -4918.53955078125,
        1097.7071533203125
      ],
      [
        -3265.078369140625,
        -4918.53955078125,
        1097.7071533203125
      ],
      [
        -3261.716064453125,
        -4919.7685546875,
        1097.7071533203125
      ],
      [
        -3265.078369140625,
        -4918.53955078125,
        1097.7071533203125
      ],
      [
        -3265.078369140625,
        -4918.78955078125,
        1098.7071533203125
      ],
      [
        -3294.93896484375,
        -4906.5400390625,
        1049.7071533203125
      ],
      [
        -3301.0830078125,
        -4896.06591796875,
        1007.81201171875
      ],
      [
        -3297.06982421875,
        -4912.78955078125,
        1074.7071533203125
      ],
      [
        -3294.93896484375,
        -4906.5400390625,
        1049.7071533203125
      ],
      [
        -3421.5,
        -4914.53955078125,
        1081.7071533203125
      ],
      [
        -3421.5,
        -4917.53955078125,
        1093.7071533203125
      ],
      [
        -3301.106689453125,
        -4915.78955078125,
        1086.7071533203125
      ],
      [
        -3305.1435546875,
        -4918.78955078125,
        1098.7071533203125
      ],
      [
        -3301.106689453125,
        -4915.78955078125,
        1086.7071533203125
      ],
      [
        -3297.06982421875,
        -4912.78955078125,
        1074.7071533203125
      ],
      [
        -3301.436767578125,
        -4894.03955078125,
        999.7071533203125
      ],
      [
        -3301.0830078125,
        -4896.06591796875,
        1007.81201171875
      ],
      [
        -3219.22412109375,
        -4919.36181640625,
        1086.7071533203125
      ],
      [
        -3219.758544921875,
        -4919.7685546875,
        1086.7071533203125
      ],
      [
        -3249.921630859375,
        -4918.53955078125,
        1097.7071533203125
      ],
      [
        -3222.96435546875,
        -4750.33740234375,
        1109.7071533203125
      ],
      [
        -3269.999755859375,
        -4850.7685546875,
        1109.7071533203125
      ],
      [
        -3232.5146484375,
        -4899.00048828125,
        1109.7071533203125
      ],
      [
        -3236.05029296875,
        -4902.53564453125,
        1109.7071533203125
      ],
      [
        -3236.05029296875,
        -4902.53564453125,
        1109.7071533203125
      ],
      [
        -3232.5146484375,
        -4906.0712890625,
        1109.7071533203125
      ],
      [
        -3199.60693359375,
        -4901.31640625,
        1109.7071533203125
      ],
      [
        -3217.36865234375,
        -4921.21728515625,
        1152.7071533203125
      ],
      [
        -3211.969970703125,
        -4926.61572265625,
        1130.0113525390625
      ],
      [
        -3199.60693359375,
        -4901.31640625,
        1109.7071533203125
      ],
      [
        -3211.46923828125,
        -4921.53955078125,
        1109.7071533203125
      ],
      [
        -3213.861083984375,
        -4894.68408203125,
        1109.7071533203125
      ],
      [
        -3211.56494140625,
        -4900.2275390625,
        1109.7071533203125
      ],
      [
        -3212.873046875,
        -4894.27490234375,
        1109.7071533203125
      ],
      [
        -3213.861083984375,
        -4894.68408203125,
        1109.7071533203125
      ],
      [
        -3278.94970703125,
        -4902.53515625,
        1109.7071533203125
      ],
      [
        -3282.4853515625,
        -4899.0,
        1109.7071533203125
      ],
      [
        -3282.4853515625,
        -4899.0,
        1109.7071533203125
      ],
      [
        -3286.02099609375,
        -4902.53515625,
        1109.7071533203125
      ],
      [
        -3270.0,
        -4851.0,
        1109.7071533203125
      ],
      [
        -3270.108154296875,
        -4851.0,
        1131.029052734375
      ],
      [
        -3270.108154296875,
        -4851.0,
        1109.7071533203125
      ],
      [
        -3270.108154296875,
        -4851.0,
        1131.029052734375
      ],
      [
        -3270.108154296875,
        -4851.0,
        1131.7071533203125
      ],
      [
        -3269.999755859375,
        -4850.7685546875,
        1109.7071533203125
      ],
      [
        -3273.653076171875,
        -4850.7685546875,
        1109.7071533203125
      ],
      [
        -3319.999755859375,
        -4850.7685546875,
        1109.7071533203125
      ],
      [
        -3316.346435546875,
        -4850.7685546875,
        1109.7071533203125
      ],
      [
        -3316.346435546875,
        -4850.7685546875,
        1109.7071533203125
      ],
      [
        -3273.653076171875,
        -4850.7685546875,
        1109.7071533203125
      ],
      [
        -3273.50732421875,
        -4851.0,
        1109.7071533203125
      ],
      [
        -3316.49267578125,
        -4851.0,
        1109.7071533203125
      ],
      [
        -3273.50732421875,
        -4851.0,
        1109.7071533203125
      ],
      [
        -3315.39306640625,
        -4901.31591796875,
        1109.7071533203125
      ],
      [
        -3303.53076171875,
        -4921.53955078125,
        1109.7071533203125
      ],
      [
        -3315.39306640625,
        -4901.31591796875,
        1109.7071533203125
      ],
      [
        -3304.261474609375,
        -4881.25439453125,
        1052.623779296875
      ],
      [
        -3301.639404296875,
        -4896.26953125,
        1052.623779296875
      ],
      [
        -3304.745361328125,
        -4878.53466796875,
        1052.623779296875
      ],
      [
        -3304.261474609375,
        -4881.25439453125,
        1052.623779296875
      ],
      [
        -3301.639404296875,
        -4896.26953125,
        1052.623779296875
      ],
      [
        -3300.79638671875,
        -4897.70654296875,
        1052.623779296875
      ],
      [
        -3213.360595703125,
        -4896.27001953125,
        1052.623779296875
      ],
      [
        -3210.738525390625,
        -4881.2548828125,
        1052.623779296875
      ],
      [
        -3210.254638671875,
        -4878.53466796875,
        1052.623779296875
      ],
      [
        -3210.738525390625,
        -4881.2548828125,
        1052.623779296875
      ],
      [
        -3213.360595703125,
        -4896.27001953125,
        1052.623779296875
      ],
      [
        -3214.20361328125,
        -4897.70751953125,
        1052.623779296875
      ],
      [
        -3295.1875,
        -4907.26904296875,
        1052.623779296875
      ],
      [
        -3219.812255859375,
        -4907.26904296875,
        1052.623779296875
      ],
      [
        -3278.94970703125,
        -4902.53515625,
        1052.623779296875
      ],
      [
        -3282.4853515625,
        -4899.0,
        1052.623779296875
      ],
      [
        -3286.02099609375,
        -4902.53515625,
        1052.623779296875
      ],
      [
        -3282.4853515625,
        -4899.0,
        1052.623779296875
      ],
      [
        -3232.5146484375,
        -4899.00048828125,
        1052.623779296875
      ],
      [
        -3236.05029296875,
        -4902.53564453125,
        1052.623779296875
      ],
      [
        -3236.05029296875,
        -4902.53564453125,
        1052.623779296875
      ],
      [
        -3232.5146484375,
        -4906.0712890625,
        1052.623779296875
      ],
      [
        -3281.114013671875,
        -4874.5,
        1097.7071533203125
      ],
      [
        -3274.322998046875,
        -4860.0,
        1097.7071533203125
      ],
      [
        -3204.376953125,
        -4899.56640625,
        1097.7071533203125
      ],
      [
        -3204.376953125,
        -4899.56640625,
        1097.7071533203125
      ],
      [
        -3215.50634765625,
        -4918.53955078125,
        1097.7071533203125
      ],
      [
        -3213.861083984375,
        -4894.68408203125,
        1097.7071533203125
      ],
      [
        -3211.56494140625,
        -4900.2275390625,
        1097.7071533203125
      ],
      [
        -3208.807861328125,
        -4892.59130859375,
        1097.7071533203125
      ],
      [
        -3213.861083984375,
        -4894.68408203125,
        1097.7071533203125
      ],
      [
        -3236.05029296875,
        -4902.53564453125,
        1097.7071533203125
      ],
      [
        -3232.5146484375,
        -4906.0712890625,
        1097.7071533203125
      ],
      [
        -3232.5146484375,
        -4899.00048828125,
        1097.7071533203125
      ],
      [
        -3236.05029296875,
        -4902.53564453125,
        1097.7071533203125
      ],
      [
        -3286.03173828125,
        -4885.00048828125,
        1107.0452880859375
      ],
      [
        -3265.094482421875,
        -4885.00048828125,
        1097.7071533203125
      ],
      [
        -3281.1142578125,
        -4874.50048828125,
        1104.85498046875
      ],
      [
        -3286.03173828125,
        -4885.00048828125,
        1107.0452880859375
      ],
      [
        -3265.094482421875,
        -4885.00048828125,
        1097.7071533203125
      ],
      [
        -3281.1142578125,
        -4874.50048828125,
        1104.85498046875
      ],
      [
        -3286.03173828125,
        -4885.00048828125,
        1107.0452880859375
      ],
      [
        -3265.094482421875,
        -4885.00048828125,
        1097.7071533203125
      ],
      [
        -3281.1142578125,
        -4874.50048828125,
        1104.85498046875
      ],
      [
        -3286.03173828125,
        -4885.00048828125,
        1107.0452880859375
      ],
      [
        -3265.094482421875,
        -4885.00048828125,
        1097.7071533203125
      ],
      [
        -3281.1142578125,
        -4874.50048828125,
        1104.85498046875
      ],
      [
        -3270.0,
        -4851.0,
        1099.8951416015625
      ],
      [
        -3270.108154296875,
        -4851.0,
        1109.7071533203125
      ],
      [
        -3270.108154296875,
        -4851.0,
        1099.9432373046875
      ],
      [
        -3278.94970703125,
        -4902.53515625,
        1103.8865966796875
      ],
      [
        -3282.4853515625,
        -4899.0,
        1105.4635009765625
      ],
      [
        -3282.4853515625,
        -4899.0,
        1105.4635009765625
      ],
      [
        -3286.02099609375,
        -4902.53515625,
        1107.04052734375
      ],
      [
        -3278.94970703125,
        -4902.53515625,
        1097.7071533203125
      ],
      [
        -3282.4853515625,
        -4899.0,
        1097.7071533203125
      ],
      [
        -3282.4853515625,
        -4899.0,
        1097.7071533203125
      ],
      [
        -3286.02099609375,
        -4902.53515625,
        1097.7071533203125
      ],
      [
        -3299.49365234375,
        -4918.53955078125,
        1097.7071533203125
      ],
      [
        -3300.429443359375,
        -4916.9443359375,
        1098.7071533203125
      ],
      [
        -3300.429443359375,
        -4916.9443359375,
        1097.7071533203125
      ],
      [
        -3300.742431640625,
        -4916.41064453125,
        1098.7071533203125
      ],
      [
        -3300.742431640625,
        -4916.41064453125,
        1097.7071533203125
      ],
      [
        -3270.0,
        -4851.0,
        1097.7071533203125
      ],
      [
        -3270.108154296875,
        -4851.0,
        1097.7071533203125
      ],
      [
        -3274.3232421875,
        -4860.0,
        1074.7071533203125
      ],
      [
        -3281.1142578125,
        -4874.5,
        1074.7071533203125
      ],
      [
        -3213.06884765625,
        -4894.35595703125,
        1052.623779296875
      ],
      [
        -3201.0166015625,
        -4889.36376953125,
        1074.7071533203125
      ],
      [
        -3208.1708984375,
        -4892.3271484375,
        1074.7071533203125
      ],
      [
        -3213.4306640625,
        -4896.3896484375,
        1052.623779296875
      ],
      [
        -3164.42626953125,
        -4882.19482421875,
        1074.7071533203125
      ],
      [
        -3148.2470703125,
        -4893.00537109375,
        1074.7071533203125
      ],
      [
        -3211.56494140625,
        -4900.2275390625,
        1065.02734375
      ],
      [
        -3213.26904296875,
        -4896.11376953125,
        1052.623779296875
      ],
      [
        -3213.11083984375,
        -4896.49560546875,
        1054.27099609375
      ],
      [
        -3213.02294921875,
        -4894.3369140625,
        1052.623779296875
      ],
      [
        -3209.616943359375,
        -4892.92626953125,
        1068.1868896484375
      ],
      [
        -3213.31396484375,
        -4896.0048828125,
        1052.623779296875
      ],
      [
        -3213.176513671875,
        -4896.3369140625,
        1053.586181640625
      ],
      [
        -3213.34765625,
        -4895.923828125,
        1052.623779296875
      ],
      [
        -3211.56494140625,
        -4900.2275390625,
        1070.380126953125
      ],
      [
        -3213.11083984375,
        -4896.49560546875,
        1054.2711181640625
      ],
      [
        -3298.1689453125,
        -4910.916015625,
        1074.7071533203125
      ],
      [
        -3295.895751953125,
        -4906.06201171875,
        1052.623779296875
      ],
      [
        -3213.861083984375,
        -4894.68408203125,
        1074.7071533203125
      ],
      [
        -3213.861083984375,
        -4894.68408203125,
        1074.7071533203125
      ],
      [
        -3211.56494140625,
        -4900.2275390625,
        1074.7071533203125
      ],
      [
        -3274.322998046875,
        -4860.0,
        1097.7071533203125
      ],
      [
        -3274.322998046875,
        -4860.0,
        1086.7071533203125
      ],
      [
        -3274.3232421875,
        -4860.0,
        1074.7071533203125
      ],
      [
        -3274.3232421875,
        -4860.0,
        1086.7071533203125
      ],
      [
        -3270.1083984375,
        -4851.00048828125,
        1081.8155517578125
      ],
      [
        -3202.718505859375,
        -4890.06884765625,
        1079.73095703125
      ],
      [
        -3202.718505859375,
        -4890.06884765625,
        1074.7071533203125
      ],
      [
        -3202.421142578125,
        -4860.00048828125,
        1086.7071533203125
      ],
      [
        -3211.669921875,
        -4911.99951171875,
        1086.7071533203125
      ],
      [
        -3205.08154296875,
        -4891.0478515625,
        1086.7071533203125
      ],
      [
        -3208.170654296875,
        -4892.32763671875,
        1086.7071533203125
      ],
      [
        -3208.1708984375,
        -4892.3271484375,
        1074.7071533203125
      ],
      [
        -3208.170654296875,
        -4892.32763671875,
        1095.826416015625
      ],
      [
        -3205.0,
        -4871.48974609375,
        1074.7071533203125
      ],
      [
        -3205.0,
        -4871.48974609375,
        1086.7071533203125
      ],
      [
        -3205.0,
        -4871.48974609375,
        1086.7071533203125
      ],
      [
        -3204.3486328125,
        -4870.83837890625,
        1086.7071533203125
      ],
      [
        -3296.77587890625,
        -4913.29052734375,
        1086.7071533203125
      ],
      [
        -3296.776123046875,
        -4913.29052734375,
        1076.7109375
      ],
      [
        -3300.42919921875,
        -4916.9443359375,
        1091.3258056640625
      ],
      [
        -3300.429443359375,
        -4916.9443359375,
        1097.7071533203125
      ],
      [
        -3296.77587890625,
        -4913.29052734375,
        1086.7071533203125
      ],
      [
        -3299.27490234375,
        -4915.78955078125,
        1086.7071533203125
      ],
      [
        -3298.168701171875,
        -4910.916015625,
        1086.7071533203125
      ],
      [
        -3298.1689453125,
        -4910.916015625,
        1074.7071533203125
      ],
      [
        -3300.7421875,
        -4916.41064453125,
        1089.1920166015625
      ],
      [
        -3298.168701171875,
        -4910.916015625,
        1086.7071533203125
      ],
      [
        -3300.451171875,
        -4915.78955078125,
        1086.7071533203125
      ],
      [
        -3421.5,
        -4860.00048828125,
        1082.623779296875
      ],
      [
        -3421.5,
        -4858.8544921875,
        1082.623779296875
      ],
      [
        -3421.5,
        -4874.50048828125,
        1082.623779296875
      ],
      [
        -3421.5,
        -4914.7685546875,
        1082.623779296875
      ],
      [
        -3421.5,
        -4874.50048828125,
        1082.623779296875
      ],
      [
        -3423.0,
        -4874.50048828125,
        1082.623779296875
      ],
      [
        -3423.0,
        -4874.50048828125,
        1082.623779296875
      ],
      [
        -3459.0,
        -4874.50048828125,
        1082.623779296875
      ],
      [
        -3505.0,
        -4825.00048828125,
        1082.623779296875
      ],
      [
        -3505.0,
        -4860.00048828125,
        1082.623779296875
      ],
      [
        -3482.0,
        -4874.50048828125,
        1082.623779296875
      ],
      [
        -3505.0,
        -4860.00048828125,
        1082.623779296875
      ],
      [
        -3453.5,
        -4874.50048828125,
        1082.623779296875
      ],
      [
        -3453.5,
        -4869.50048828125,
        1082.623779296875
      ],
      [
        -3463.5,
        -4874.50048828125,
        1082.623779296875
      ],
      [
        -3463.5,
        -4869.50048828125,
        1082.623779296875
      ],
      [
        -3458.5,
        -4874.50048828125,
        1082.623779296875
      ],
      [
        -3458.5,
        -4871.00048828125,
        1082.623779296875
      ],
      [
        -3421.5,
        -4860.00048828125,
        1082.623779296875
      ],
      [
        -3423.0,
        -4860.00048828125,
        1082.623779296875
      ],
      [
        -3340.0,
        -4875.4169921875,
        1082.623779296875
      ],
      [
        -3380.0,
        -4875.4169921875,
        1082.623779296875
      ],
      [
        -3277.8359375,
        -4867.50048828125,
        1074.7071533203125
      ],
      [
        -3310.0,
        -4867.50048828125,
        1074.7071533203125
      ],
      [
        -3301.569580078125,
        -4896.38818359375,
        1052.623779296875
      ],
      [
        -3310.0,
        -4874.5,
        1081.70703125
      ],
      [
        -3305.85302734375,
        -4897.8154296875,
        1082.623779296875
      ],
      [
        -3309.8369140625,
        -4875.41650390625,
        1082.623779296875
      ],
      [
        -3305.85302734375,
        -4897.8154296875,
        1082.623779296875
      ],
      [
        -3298.168701171875,
        -4910.916015625,
        1082.623779296875
      ],
      [
        -3310.0,
        -4867.50048828125,
        1074.7071533203125
      ],
      [
        -3310.0,
        -4874.5,
        1081.70703125
      ],
      [
        -3380.0,
        -4859.083984375,
        1082.623779296875
      ],
      [
        -3340.0,
        -4859.083984375,
        1082.623779296875
      ],
      [
        -3310.0,
        -4860.0,
        1081.7073974609375
      ],
      [
        -3274.3232421875,
        -4860.0,
        1081.7073974609375
      ],
      [
        -3270.91650390625,
        -4851.00048828125,
        1082.623779296875
      ],
      [
        -3270.1083984375,
        -4851.00048828125,
        1082.623779296875
      ],
      [
        -3277.601806640625,
        -4867.00048828125,
        1074.7071533203125
      ],
      [
        -3310.0,
        -4867.00048828125,
        1074.7071533203125
      ],
      [
        -3310.0,
        -4860.0,
        1081.7073974609375
      ],
      [
        -3310.0,
        -4867.00048828125,
        1074.7071533203125
      ],
      [
        -3410.0,
        -4860.00048828125,
        1082.623779296875
      ],
      [
        -3406.33349609375,
        -4860.00048828125,
        1082.623779296875
      ],
      [
        -3310.0,
        -4860.0,
        1082.623779296875
      ],
      [
        -3274.3232421875,
        -4860.0,
        1082.623779296875
      ],
      [
        -3380.0,
        -4860.00048828125,
        1082.623779296875
      ],
      [
        -3380.0,
        -4859.083984375,
        1082.623779296875
      ],
      [
        -3310.0,
        -4860.0,
        1082.623779296875
      ],
      [
        -3310.0,
        -4874.5,
        1082.623779296875
      ],
      [
        -3410.0,
        -4874.50048828125,
        1082.623779296875
      ],
      [
        -3406.33349609375,
        -4874.50048828125,
        1082.623779296875
      ],
      [
        -3380.0,
        -4875.4169921875,
        1082.623779296875
      ],
      [
        -3380.0,
        -4874.50048828125,
        1082.623779296875
      ],
      [
        -3310.0,
        -4874.5,
        1082.623779296875
      ],
      [
        -3252.30126953125,
        -4812.8701171875,
        1085.6170654296875
      ],
      [
        -3254.840087890625,
        -4818.306640625,
        1085.6160888671875
      ],
      [
        -3252.30126953125,
        -4812.8701171875,
        1085.6170654296875
      ],
      [
        -3252.30126953125,
        -4812.8701171875,
        1082.623779296875
      ],
      [
        -3254.840087890625,
        -4818.306640625,
        1082.623779296875
      ],
      [
        -3254.840087890625,
        -4818.306640625,
        1085.6160888671875
      ],
      [
        -3458.5,
        -4874.50048828125,
        1091.7071533203125
      ],
      [
        -3458.5,
        -4871.00048828125,
        1092.18994140625
      ],
      [
        -3463.5,
        -4874.50048828125,
        1083.7071533203125
      ],
      [
        -3463.5,
        -4869.50048828125,
        1083.7071533203125
      ],
      [
        -3453.5,
        -4874.50048828125,
        1083.7071533203125
      ],
      [
        -3453.5,
        -4869.50048828125,
        1083.7071533203125
      ],
      [
        -3458.5,
        -4874.50048828125,
        1083.7071533203125
      ],
      [
        -3458.5,
        -4871.00048828125,
        1083.7071533203125
      ],
      [
        -3270.108154296875,
        -4851.0,
        1098.6622314453125
      ],
      [
        -3275.26806640625,
        -4851.0,
        1098.6622314453125
      ],
      [
        -3314.73193359375,
        -4851.0,
        1098.6622314453125
      ],
      [
        -3275.26806640625,
        -4851.0,
        1098.6622314453125
      ],
      [
        -3379.258056640625,
        -4855.7421875,
        1099.448974609375
      ],
      [
        -3340.0,
        -4855.7421875,
        1099.448974609375
      ],
      [
        -3320.0,
        -4866.0,
        1109.7071533203125
      ],
      [
        -3320.0,
        -4860.00048828125,
        1103.70751953125
      ],
      [
        -3375.98291015625,
        -4875.4833984375,
        1102.72412109375
      ],
      [
        -3340.0,
        -4875.4833984375,
        1102.72412109375
      ],
      [
        -3315.39306640625,
        -4901.31591796875,
        1107.010009765625
      ],
      [
        -3320.0,
        -4874.5,
        1103.707275390625
      ],
      [
        -3319.8310546875,
        -4875.4833984375,
        1102.72412109375
      ],
      [
        -3305.857666015625,
        -4917.57275390625,
        1109.7071533203125
      ],
      [
        -3315.39306640625,
        -4901.31591796875,
        1107.010009765625
      ],
      [
        -3320.0,
        -4874.5,
        1103.707275390625
      ],
      [
        -3320.0,
        -4868.50048828125,
        1109.7071533203125
      ],
      [
        -3376.14599609375,
        -4874.50048828125,
        1102.56103515625
      ],
      [
        -3375.98291015625,
        -4875.4833984375,
        1102.72412109375
      ],
      [
        -3378.5517578125,
        -4860.00048828125,
        1100.1553955078125
      ],
      [
        -3379.25830078125,
        -4855.7421875,
        1099.448974609375
      ],
      [
        -3378.5517578125,
        -4860.00048828125,
        1100.1553955078125
      ],
      [
        -3376.14599609375,
        -4874.50048828125,
        1102.56103515625
      ],
      [
        -3320.0,
        -4874.5,
        1102.56103515625
      ],
      [
        -3320.0,
        -4860.00048828125,
        1100.1553955078125
      ],
      [
        -3320.0,
        -4874.5,
        1102.56103515625
      ],
      [
        -3269.999755859375,
        -4850.7685546875,
        1098.623779296875
      ],
      [
        -3275.420166015625,
        -4850.7685546875,
        1098.623779296875
      ],
      [
        -3319.999755859375,
        -4850.7685546875,
        1098.623779296875
      ],
      [
        -3314.579345703125,
        -4850.7685546875,
        1098.623779296875
      ],
      [
        -3314.579345703125,
        -4850.7685546875,
        1098.623779296875
      ],
      [
        -3275.420166015625,
        -4850.7685546875,
        1098.623779296875
      ],
      [
        -3319.999755859375,
        -4825.7685546875,
        1094.47607421875
      ],
      [
        -3319.999755859375,
        -4825.7685546875,
        1094.47607421875
      ],
      [
        -3319.999755859375,
        -4825.7685546875,
        1089.583984375
      ],
      [
        -3410.0,
        -4895.50048828125,
        1082.7071533203125
      ],
      [
        -3410.0,
        -4879.5,
        1098.7071533203125
      ],
      [
        -3319.8310546875,
        -4875.4833984375,
        1102.72412109375
      ],
      [
        -3319.140869140625,
        -4879.5,
        1098.7071533203125
      ],
      [
        -3335.0,
        -4879.92626953125,
        1098.2816162109375
      ],
      [
        -3320.0,
        -4879.92578125,
        1098.2816162109375
      ],
      [
        -3335.0,
        -4886.82861328125,
        1091.379150390625
      ],
      [
        -3335.0,
        -4900.00048828125,
        1092.304443359375
      ],
      [
        -3335.0,
        -4879.92626953125,
        1098.2816162109375
      ],
      [
        -3310.623046875,
        -4899.56591796875,
        1095.94091796875
      ],
      [
        -3300.742431640625,
        -4916.41064453125,
        1098.610595703125
      ],
      [
        -3310.623046875,
        -4899.56591796875,
        1095.94091796875
      ],
      [
        -3314.126953125,
        -4879.5,
        1098.7071533203125
      ],
      [
        -3313.3779296875,
        -4883.78955078125,
        1094.418212890625
      ],
      [
        -3275.499755859375,
        -4850.7685546875,
        1097.7965087890625
      ],
      [
        -3319.999755859375,
        -4850.7685546875,
        1094.475341796875
      ],
      [
        -3314.499755859375,
        -4850.7685546875,
        1094.475341796875
      ],
      [
        -3294.5,
        -4851.0,
        1094.9544677734375
      ],
      [
        -3295.5,
        -4851.0,
        1094.8040771484375
      ],
      [
        -3270.108154296875,
        -4851.0,
        1098.623779296875
      ],
      [
        -3275.401123046875,
        -4851.0,
        1097.8275146484375
      ],
      [
        -3279.52490234375,
        -4851.0,
        1097.2071533203125
      ],
      [
        -3275.401123046875,
        -4851.0,
        1097.8275146484375
      ],
      [
        -3295.5,
        -4853.5,
        1097.2071533203125
      ],
      [
        -3314.5,
        -4853.5,
        1097.2071533203125
      ],
      [
        -3280.692626953125,
        -4853.5,
        1097.2071533203125
      ],
      [
        -3279.52490234375,
        -4851.0,
        1097.2071533203125
      ],
      [
        -3294.5,
        -4853.5,
        1097.2071533203125
      ],
      [
        -3295.5,
        -4851.1044921875,
        1094.8114013671875
      ],
      [
        -3295.5,
        -4851.0,
        1094.8040771484375
      ],
      [
        -3295.5,
        -4853.5,
        1097.2071533203125
      ],
      [
        -3294.5,
        -4853.5,
        1097.2071533203125
      ],
      [
        -3294.5,
        -4851.0,
        1094.9544677734375
      ],
      [
        -3294.5,
        -4851.26611328125,
        1094.97314453125
      ],
      [
        -3314.5,
        -4853.5,
        1097.2071533203125
      ],
      [
        -3314.5,
        -4851.0,
        1094.70703125
      ],
      [
        -3319.999755859375,
        -4825.7685546875,
        1089.583984375
      ],
      [
        -3319.999755859375,
        -4847.25830078125,
        1090.96484375
      ],
      [
        -3319.999755859375,
        -4850.7685546875,
        1094.475341796875
      ],
      [
        -3363.7841796875,
        -4879.50048828125,
        1086.7071533203125
      ],
      [
        -3340.0,
        -4879.50048828125,
        1090.145263671875
      ],
      [
        -3410.0,
        -4879.50048828125,
        1082.7071533203125
      ],
      [
        -3335.0,
        -4879.50048828125,
        1098.3150634765625
      ],
      [
        -3320.0,
        -4879.50048828125,
        1098.31494140625
      ],
      [
        -3314.126953125,
        -4879.5,
        1098.3150634765625
      ],
      [
        -3314.052734375,
        -4879.92529296875,
        1098.28173828125
      ],
      [
        -3335.0,
        -4879.50048828125,
        1090.8682861328125
      ],
      [
        -3335.0,
        -4880.1484375,
        1090.909912109375
      ],
      [
        -3335.0,
        -4879.50048828125,
        1098.3150634765625
      ],
      [
        -3314.126953125,
        -4879.50048828125,
        1094.0042724609375
      ],
      [
        -3340.0,
        -4855.00048828125,
        1088.571044921875
      ],
      [
        -3352.893798828125,
        -4855.00048828125,
        1086.7071533203125
      ],
      [
        -3295.5,
        -4855.00048828125,
        1097.2071533203125
      ],
      [
        -3314.5,
        -4855.00048828125,
        1097.2071533203125
      ],
      [
        -3281.3935546875,
        -4855.00048828125,
        1097.2071533203125
      ],
      [
        -3294.5,
        -4855.00048828125,
        1097.2071533203125
      ],
      [
        -3319.999755859375,
        -4850.7685546875,
        1091.1904296875
      ],
      [
        -3314.499755859375,
        -4850.7685546875,
        1091.985595703125
      ],
      [
        -3314.5,
        -4855.00048828125,
        1097.2071533203125
      ],
      [
        -3314.5,
        -4851.0,
        1092.0003662109375
      ],
      [
        -3314.5,
        -4855.00048828125,
        1092.2574462890625
      ],
      [
        -3295.5,
        -4855.00048828125,
        1095.0850830078125
      ],
      [
        -3295.5,
        -4855.00048828125,
        1097.2071533203125
      ],
      [
        -3294.5,
        -4855.00048828125,
        1097.2071533203125
      ],
      [
        -3294.5,
        -4855.00048828125,
        1095.2354736328125
      ],
      [
        -3319.999755859375,
        -4850.7685546875,
        1091.1904296875
      ],
      [
        -3380.0,
        -4858.6826171875,
        1083.0250244140625
      ],
      [
        -3352.893798828125,
        -4855.00048828125,
        1086.7071533203125
      ],
      [
        -3361.561279296875,
        -4874.50048828125,
        1086.7071533203125
      ],
      [
        -3355.116455078125,
        -4860.00048828125,
        1086.7071533203125
      ],
      [
        -3410.0,
        -4874.50048828125,
        1086.7071533203125
      ],
      [
        -3363.7841796875,
        -4879.50048828125,
        1086.7071533203125
      ],
      [
        -3380.0,
        -4876.9951171875,
        1084.201904296875
      ],
      [
        -3410.0,
        -4879.50048828125,
        1086.7071533203125
      ],
      [
        -3410.0,
        -4875.50048828125,
        1086.7071533203125
      ],
      [
        -3380.0,
        -4876.9951171875,
        1084.201904296875
      ],
      [
        -3380.0,
        -4874.50048828125,
        1084.04150390625
      ],
      [
        -3410.0,
        -4860.00048828125,
        1086.7071533203125
      ],
      [
        -3380.0,
        -4860.00048828125,
        1083.10986328125
      ],
      [
        -3380.0,
        -4858.6826171875,
        1083.0250244140625
      ],
      [
        -3335.0,
        -4860.0,
        1089.6151123046875
      ],
      [
        -3337.0,
        -4860.00048828125,
        1089.3260498046875
      ],
      [
        -3340.0,
        -4860.00048828125,
        1088.8922119140625
      ],
      [
        -3337.0,
        -4860.00048828125,
        1089.3260498046875
      ],
      [
        -3335.0,
        -4860.0,
        1089.6151123046875
      ],
      [
        -3315.0,
        -4860.0,
        1092.5029296875
      ],
      [
        -3280.405029296875,
        -4860.0,
        1097.7071533203125
      ],
      [
        -3282.327392578125,
        -4857.0,
        1097.2071533203125
      ],
      [
        -3282.327392578125,
        -4857.0,
        1097.2071533203125
      ],
      [
        -3380.0,
        -4855.00048828125,
        1097.2071533203125
      ],
      [
        -3380.0,
        -4857.0,
        1097.2071533203125
      ],
      [
        -3380.0,
        -4860.00048828125,
        1097.707275390625
      ],
      [
        -3314.5,
        -4855.00048828125,
        1096.8739013671875
      ],
      [
        -3380.0,
        -4855.00048828125,
        1096.8739013671875
      ],
      [
        -3294.5,
        -4855.00048828125,
        1096.8739013671875
      ],
      [
        -3295.5,
        -4855.00048828125,
        1096.8739013671875
      ],
      [
        -3315.0,
        -4860.0,
        1092.5030517578125
      ],
      [
        -3314.5,
        -4857.0,
        1092.385986328125
      ],
      [
        -3314.5,
        -4857.0,
        1092.3858642578125
      ],
      [
        -3295.0,
        -4860.0,
        1095.5115966796875
      ],
      [
        -3295.5,
        -4857.0,
        1095.2255859375
      ],
      [
        -3295.0,
        -4860.0,
        1095.5115966796875
      ],
      [
        -3294.5,
        -4857.0,
        1095.3759765625
      ],
      [
        -3295.5,
        -4857.0,
        1095.2255859375
      ],
      [
        -3294.5,
        -4857.0,
        1095.3759765625
      ],
      [
        -3287.176513671875,
        -4874.5,
        1097.7071533203125
      ],
      [
        -3280.405029296875,
        -4860.0,
        1097.7071533203125
      ],
      [
        -3394.0,
        -4874.50048828125,
        1097.7071533203125
      ],
      [
        -3394.0,
        -4860.00048828125,
        1097.7071533203125
      ],
      [
        -3410.0,
        -4879.5,
        1097.7071533203125
      ],
      [
        -3410.0,
        -4875.50048828125,
        1097.7071533203125
      ],
      [
        -3314.126953125,
        -4879.5,
        1097.7071533203125
      ],
      [
        -3324.999755859375,
        -4874.5,
        1098.7071533203125
      ],
      [
        -3323.039306640625,
        -4879.50048828125,
        1098.31494140625
      ],
      [
        -3315.0,
        -4874.5,
        1097.7071533203125
      ],
      [
        -3320.0,
        -4874.5,
        1097.7071533203125
      ],
      [
        -3380.0,
        -4879.50048828125,
        1098.3150634765625
      ],
      [
        -3389.33349609375,
        -4874.50048828125,
        1097.7071533203125
      ],
      [
        -3380.66650390625,
        -4874.50048828125,
        1097.7071533203125
      ],
      [
        -3380.0,
        -4874.50048828125,
        1097.7071533203125
      ],
      [
        -3380.66650390625,
        -4874.50048828125,
        1097.7071533203125
      ],
      [
        -3389.33349609375,
        -4874.50048828125,
        1097.7071533203125
      ],
      [
        -3390.0,
        -4874.50048828125,
        1097.7071533203125
      ],
      [
        -3335.0,
        -4874.50048828125,
        1097.7071533203125
      ],
      [
        -3337.0,
        -4874.50048828125,
        1097.7071533203125
      ],
      [
        -3340.0,
        -4874.50048828125,
        1097.7071533203125
      ],
      [
        -3337.0,
        -4874.50048828125,
        1097.7071533203125
      ],
      [
        -3390.0,
        -4874.50048828125,
        1097.7071533203125
      ],
      [
        -3394.0,
        -4874.50048828125,
        1097.7071533203125
      ],
      [
        -3335.0,
        -4874.50048828125,
        1097.7071533203125
      ],
      [
        -3335.0,
        -4879.50048828125,
        1097.7071533203125
      ],
      [
        -3380.0,
        -4879.50048828125,
        1097.7071533203125
      ],
      [
        -3380.0,
        -4874.50048828125,
        1097.7071533203125
      ],
      [
        -3335.0,
        -4874.5,
        1090.546875
      ],
      [
        -3337.0,
        -4874.50048828125,
        1090.2578125
      ],
      [
        -3340.0,
        -4874.50048828125,
        1089.8240966796875
      ],
      [
        -3337.0,
        -4874.50048828125,
        1090.2578125
      ],
      [
        -3315.0,
        -4874.5,
        1093.5216064453125
      ],
      [
        -3320.0,
        -4874.5,
        1092.7694091796875
      ],
      [
        -3335.0,
        -4874.5,
        1090.546875
      ],
      [
        -3315.0,
        -4874.5,
        1093.5216064453125
      ],
      [
        -3320.0,
        -4874.5,
        1092.76953125
      ],
      [
        -3320.0,
        -4860.0,
        1091.7835693359375
      ],
      [
        -3320.0,
        -4865.4658203125,
        1092.1348876953125
      ],
      [
        -3260.6728515625,
        -4778.50830078125,
        1094.9505615234375
      ],
      [
        -3319.999755859375,
        -4825.7685546875,
        1089.3460693359375
      ],
      [
        -3380.0,
        -4859.04931640625,
        1082.6583251953125
      ],
      [
        -3351.1943359375,
        -4855.00048828125,
        1086.7071533203125
      ],
      [
        -3319.999755859375,
        -4825.7685546875,
        1089.3460693359375
      ],
      [
        -3319.999755859375,
        -4850.61572265625,
        1091.0916748046875
      ],
      [
        -3319.999755859375,
        -4850.5322265625,
        1091.17529296875
      ],
      [
        -3362.635986328125,
        -4879.50048828125,
        1086.7071533203125
      ],
      [
        -3340.0,
        -4879.50048828125,
        1090.1123046875
      ],
      [
        -3335.0,
        -4879.50048828125,
        1090.8643798828125
      ],
      [
        -3335.0,
        -4879.50048828125,
        1090.8682861328125
      ],
      [
        -3335.0,
        -4860.0,
        1089.494384765625
      ],
      [
        -3337.0,
        -4860.00048828125,
        1089.193603515625
      ],
      [
        -3340.0,
        -4860.00048828125,
        1088.7423095703125
      ],
      [
        -3337.0,
        -4860.00048828125,
        1089.193603515625
      ],
      [
        -3335.0,
        -4860.0,
        1089.494384765625
      ],
      [
        -3340.0,
        -4855.00048828125,
        1088.39111328125
      ],
      [
        -3351.1943359375,
        -4855.00048828125,
        1086.7071533203125
      ],
      [
        -3319.999755859375,
        -4850.7685546875,
        1091.1024169921875
      ],
      [
        -3314.499755859375,
        -4850.7685546875,
        1091.9296875
      ],
      [
        -3314.5,
        -4855.00048828125,
        1092.2574462890625
      ],
      [
        -3314.5,
        -4851.0,
        1091.9459228515625
      ],
      [
        -3314.5,
        -4855.00048828125,
        1092.2269287109375
      ],
      [
        -3319.999755859375,
        -4850.7685546875,
        1091.1024169921875
      ],
      [
        -3314.5,
        -4857.0,
        1092.3675537109375
      ],
      [
        -3314.5,
        -4857.0,
        1092.367431640625
      ],
      [
        -3380.0,
        -4860.00048828125,
        1082.72509765625
      ],
      [
        -3380.0,
        -4859.04931640625,
        1082.6583251953125
      ],
      [
        -3362.635986328125,
        -4879.50048828125,
        1086.7071533203125
      ],
      [
        -3380.0,
        -4876.69091796875,
        1083.8975830078125
      ],
      [
        -3360.30029296875,
        -4874.50048828125,
        1086.7071533203125
      ],
      [
        -3353.52880859375,
        -4860.00048828125,
        1086.7071533203125
      ],
      [
        -3380.0,
        -4876.69091796875,
        1083.8975830078125
      ],
      [
        -3380.0,
        -4874.50048828125,
        1083.7437744140625
      ],
      [
        -3320.0,
        -4860.0,
        1091.7508544921875
      ],
      [
        -3335.0,
        -4874.5,
        1090.5130615234375
      ],
      [
        -3335.0,
        -4874.5,
        1090.5130615234375
      ],
      [
        -3337.0,
        -4874.50048828125,
        1090.2122802734375
      ],
      [
        -3340.0,
        -4874.50048828125,
        1089.760986328125
      ],
      [
        -3337.0,
        -4874.50048828125,
        1090.2122802734375
      ],
      [
        -3260.000244140625,
        -4778.81689453125,
        1095.0733642578125
      ],
      [
        -3260.6728515625,
        -4778.50830078125,
        1094.9505615234375
      ],
      [
        -3260.000244140625,
        -4778.81689453125,
        1095.0733642578125
      ],
      [
        -3267.583251953125,
        -4797.4814453125,
        1095.243896484375
      ],
      [
        -3268.844482421875,
        -4796.89306640625,
        1095.012939453125
      ],
      [
        -3269.250732421875,
        -4797.80712890625,
        1095.0159912109375
      ],
      [
        -3268.34765625,
        -4798.22802734375,
        1095.181396484375
      ],
      [
        -3311.71142578125,
        -4893.33349609375,
        1086.7071533203125
      ],
      [
        -3314.126953125,
        -4879.5,
        1086.7071533203125
      ],
      [
        -3309.110595703125,
        -4879.5,
        1086.7071533203125
      ],
      [
        -3308.0966796875,
        -4885.201171875,
        1086.7071533203125
      ],
      [
        -3320.0,
        -4879.5,
        1086.7071533203125
      ],
      [
        -3335.0,
        -4879.5,
        1086.7071533203125
      ],
      [
        -3308.0966796875,
        -4885.201171875,
        1086.7071533203125
      ],
      [
        -3309.110595703125,
        -4879.5,
        1086.7071533203125
      ],
      [
        -3309.8369140625,
        -4875.41650390625,
        1082.623779296875
      ],
      [
        -3308.0966796875,
        -4885.201171875,
        1082.623779296875
      ],
      [
        -3335.0,
        -4879.5,
        1086.7071533203125
      ],
      [
        -3335.0,
        -4883.9716796875,
        1091.178466796875
      ],
      [
        -3311.71142578125,
        -4893.33349609375,
        1095.33935546875
      ],
      [
        -3312.716552734375,
        -4887.57666015625,
        1094.78369140625
      ],
      [
        -3314.126953125,
        -4879.5,
        1086.7071533203125
      ],
      [
        -3311.71142578125,
        -4893.33349609375,
        1086.7071533203125
      ],
      [
        -3319.999755859375,
        -4850.7685546875,
        1090.938720703125
      ],
      [
        -3319.999755859375,
        -4850.61572265625,
        1091.0916748046875
      ],
      [
        -3319.999755859375,
        -4850.7685546875,
        1090.938720703125
      ],
      [
        -3314.499755859375,
        -4850.7685546875,
        1090.9388427734375
      ],
      [
        -3292.791748046875,
        -4850.7685546875,
        1088.123779296875
      ],
      [
        -3292.791748046875,
        -4850.7685546875,
        1082.623779296875
      ],
      [
        -3314.5,
        -4854.50048828125,
        1087.2071533203125
      ],
      [
        -3295.5,
        -4854.5,
        1087.2071533203125
      ],
      [
        -3294.5,
        -4854.5,
        1087.2071533203125
      ],
      [
        -3292.89453125,
        -4851.0,
        1087.2071533203125
      ],
      [
        -3294.4501953125,
        -4854.5,
        1087.2071533203125
      ],
      [
        -3295.5,
        -4854.5,
        1087.2071533203125
      ],
      [
        -3295.5,
        -4851.0,
        1090.707275390625
      ],
      [
        -3294.5,
        -4851.0,
        1090.70751953125
      ],
      [
        -3294.5,
        -4854.5,
        1087.2071533203125
      ],
      [
        -3294.5,
        -4851.0,
        1090.70751953125
      ],
      [
        -3295.5,
        -4851.0,
        1090.707275390625
      ],
      [
        -3314.5,
        -4851.0,
        1090.7071533203125
      ],
      [
        -3314.5,
        -4854.50048828125,
        1087.2071533203125
      ],
      [
        -3296.89501953125,
        -4860.0,
        1086.7071533203125
      ],
      [
        -3296.89501953125,
        -4860.0,
        1082.623779296875
      ],
      [
        -3295.5615234375,
        -4857.0,
        1087.2071533203125
      ],
      [
        -3295.5,
        -4856.86181640625,
        1087.2071533203125
      ],
      [
        -3294.5,
        -4854.61181640625,
        1087.2071533203125
      ],
      [
        -3296.89501953125,
        -4860.0,
        1086.7071533203125
      ],
      [
        -3295.5615234375,
        -4857.0,
        1087.2071533203125
      ],
      [
        -3340.0,
        -4855.00048828125,
        1087.2071533203125
      ],
      [
        -3347.87060546875,
        -4855.00048828125,
        1087.2071533203125
      ],
      [
        -3315.0,
        -4860.0,
        1087.2071533203125
      ],
      [
        -3295.5,
        -4856.86181640625,
        1087.2071533203125
      ],
      [
        -3295.5,
        -4856.86181640625,
        1095.2158203125
      ],
      [
        -3294.5,
        -4854.61181640625,
        1095.208251953125
      ],
      [
        -3294.5,
        -4854.61181640625,
        1087.2071533203125
      ],
      [
        -3314.126708984375,
        -4879.50048828125,
        1094.0042724609375
      ],
      [
        -3335.0,
        -4879.50048828125,
        1090.8643798828125
      ],
      [
        -3275.5,
        -4851.0,
        1088.2071533203125
      ],
      [
        -3294.5,
        -4854.61181640625,
        1087.6051025390625
      ],
      [
        -3295.5,
        -4856.86181640625,
        1087.230224609375
      ],
      [
        -3275.5,
        -4860.0,
        1097.7071533203125
      ],
      [
        -3254.27001953125,
        -4812.61181640625,
        1085.112060546875
      ],
      [
        -3256.60107421875,
        -4817.4853515625,
        1085.0980224609375
      ],
      [
        -3257.18603515625,
        -4817.212890625,
        1084.9259033203125
      ],
      [
        -3255.004150390625,
        -4812.4951171875,
        1084.9215087890625
      ],
      [
        -3256.79296875,
        -4816.36328125,
        1084.925048828125
      ],
      [
        -3256.302978515625,
        -4816.8623046875,
        1085.0997314453125
      ],
      [
        -3254.667236328125,
        -4811.76708984375,
        1084.9208984375
      ],
      [
        -3254.01220703125,
        -4812.07275390625,
        1085.1136474609375
      ]
    ]
  },
  "sectors": [
    {
      "plane_normal": [
        -0.9268880486488342,
        4.242956919142671e-08,
        -0.3753378987312317
      ],
      "plane_d": -2475.258544921875,
      "bbox_min": [
        -3164.084228515625,
        -4965.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3116.600341796875,
        -4329.7685546875,
        1112.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9712973833084106,
        0.0,
        0.23786836862564087
      ],
      "plane_d": -3289.187255859375,
      "bbox_min": [
        -3164.084228515625,
        -4965.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3116.600341796875,
        -4329.7685546875,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1052.623779296875,
      "bbox_min": [
        -3164.084228515625,
        -4965.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3122.9287109375,
        -4409.7685546875,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5745896697044373,
        0.7548813819885254,
        -0.31622910499572754
      ],
      "plane_d": 5974.23974609375,
      "bbox_min": [
        -3304.29443359375,
        -4932.2890625,
        1128.572509765625
      ],
      "bbox_max": [
        -3283.0849609375,
        -4920.81591796875,
        1152.7071533203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.407327264547348,
        0.0,
        -0.9132823348045349
      ],
      "plane_d": -327.4454345703125,
      "bbox_min": [
        -3286.03173828125,
        -4902.53515625,
        1097.7071533203125
      ],
      "bbox_max": [
        -3265.078369140625,
        -4851.0,
        1109.7071533203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071064114570618,
        0.7071071863174438,
        0.0
      ],
      "plane_d": 1143.0516357421875,
      "bbox_min": [
        -3300.742431640625,
        -4918.78955078125,
        1097.7071533203125
      ],
      "bbox_max": [
        -3282.4853515625,
        -4899.0,
        1107.04052734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": 4851.0,
      "bbox_min": [
        -3270.108154296875,
        -4851.0,
        1097.7071533203125
      ],
      "bbox_max": [
        -3270.0,
        -4851.0,
        1099.9432373046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1086.7071533203125,
      "bbox_min": [
        -3300.451171875,
        -4915.78955078125,
        1086.7071533203125
      ],
      "bbox_max": [
        -3296.77587890625,
        -4910.916015625,
        1086.7071533203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7071068286895752,
        0.7071068286895752
      ],
      "plane_d": -4201.421875,
      "bbox_min": [
        -3410.0,
        -4875.4169921875,
        1074.7071533203125
      ],
      "bbox_max": [
        -3270.1083984375,
        -4851.00048828125,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9855617880821228,
        0.16931606829166412,
        0.0
      ],
      "plane_d": 4097.396484375,
      "bbox_min": [
        -3320.0,
        -4917.57275390625,
        1102.72412109375
      ],
      "bbox_max": [
        -3281.1142578125,
        -4868.50048828125,
        1109.7071533203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8625617027282715,
        0.5059519410133362,
        -0.0
      ],
      "plane_d": 5339.5615234375,
      "bbox_min": [
        -3320.0,
        -4917.57275390625,
        1103.707275390625
      ],
      "bbox_max": [
        -3281.1142578125,
        -4868.50048828125,
        1109.7071533203125
      ],
      "face_count": 1
    }
  ],
  "placed_objects": [
    {
      "tag": "CGameArea piece: jct02",
      "entity_class": "CGameArea",
      "piece_name": "jct02",
      "offset": 54,
      "centroid": [
        -3278.3662109375,
        -4830.14306640625,
        1089.8118896484375
      ],
      "bbox_min": [
        -3316.0,
        -4859.5,
        1082.623779296875
      ],
      "bbox_max": [
        -3259.259033203125,
        -4799.6845703125,
        1098.0
      ],
      "dimensions_source": {
        "span_x": 56.740966796875,
        "span_y": 59.8154296875,
        "height_z": 15.376220703125,
        "door_width": 59.8154296875,
        "door_depth": 56.740966796875,
        "leaf_depth": 56.740966796875,
        "clearance_margin": 0.0,
        "slide_axis": "z",
        "slide_vector": [
          0.0,
          1.0,
          -0.0
        ]
      },
      "vertices": [
        [
          -3316.0,
          -4859.5,
          1086.0
        ],
        [
          -3274.0,
          -4859.5,
          1086.0
        ],
        [
          -3274.0,
          -4859.5,
          1098.0
        ],
        [
          -3316.0,
          -4859.5,
          1098.0
        ],
        [
          -3264.205810546875,
          -4799.6845703125,
          1082.623779296875
        ],
        [
          -3264.205810546875,
          -4799.6845703125,
          1092.623779296875
        ],
        [
          -3259.259033203125,
          -4801.8876953125,
          1092.623779296875
        ],
        [
          -3259.259033203125,
          -4801.8876953125,
          1082.623779296875
        ]
      ],
      "plane_distance": 4859.5
    }
  ],
  "tutorial_messages": []
}